import { ChangeDetectionStrategy, Component, Injector, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { HeaderOptions } from '@src/app/components';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PermissionService } from '@src/app/modules/user-info/services';
import { DialogConfirmComponent } from '@src/app/shared/dialogs';
import { UserService } from '@src/core/services';
import { UserUI } from '@src/models';

@Component({
  selector: 'app-birthdays-page',
  templateUrl: './birthdays-page.component.html',
  styleUrls: ['./birthdays-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BirthdaysPageComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly permissionService = inject(PermissionService);
  private readonly userService = inject(UserService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  selectedId?: string;

  headerOptions: HeaderOptions = {
    title: this.translateService.instant('components.birthdaysPage.labels.userInfoTitle'),
    buttons: {
      left: {
        label: '',
        icon: '@tui.chevron-left',
        visible: () => !this.isLargeScreen,
        action: () => {
          this.selectedId = undefined;
        },
      },
    },
  };

  private readonly confirmDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('common.dialogs.userDeleteHeader'),
      size: 's',
      closeable: false,
    },
  );

  get showFullPage(): boolean {
    return !this.selectedId || this.isLargeScreen;
  }

  get allowDeleting(): boolean {
    return this.permissionService.allowDeleting$.value && this.selectedId !== this.userService.authUser$.value?.id;
  }

  onDeleteUser(user?: UserUI): void {
    const id = user?.id;
    if (!id) return;

    this.confirmDialog.pipe(takeUntil(this.destroyed$$)).subscribe({
      next: res => {
        if (res) {
          this.userService
            .deleteUser(id)
            .pipe(takeUntil(this.destroyed$$))
            .subscribe(() => {
              this.selectedId = undefined;
            });
        }
      },
    });
  }
}
